import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=46ef03c8&scoped=true&"
import script from "./Allocation.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Allocation.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Allocation.vue?vue&type=style&index=0&id=46ef03c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ef03c8",
  null
  
)

export default component.exports